import CopyIcon from "../../../assets/Images/copy-icon.svg"
import atoms from "../../../components/atoms"
import constant from "../../../constants/constant";
import { findConstantLabel } from "../../../constants/utils";
import { TWarrantyModalProps } from "./interface";

const {Image} = atoms;



export const WarrantyModal=({warrantDetail}:TWarrantyModalProps)=>{
    return(
        <>
        <div className=' d-flex gap-3 align-items-center p-0 mb-4'>
            <h2 className='mb-0 fs-16 fw-700 secondary-color p-0 info-text'>Claim ID:</h2>
            <div className='d-flex w-auto justify-content-around align-items-center p-2 add-product-custom-div cursor-pointer' >
                <h2 className='mb-0 fs-16 fw-400 secondary-color'>{warrantDetail?.claim_id}</h2>
                <div className='ms-2'>
                    <Image src={CopyIcon} onClick={() => navigator.clipboard.writeText(warrantDetail?.claim_id)} />
                </div>
            </div>
        </div>
        <hr className="mt-3" style={{ border: '1px dashed #222', }} />

        <div className='row'>
            <div className='col-md-4 d-flex gap-2 d-md-block'>
                <h2 className='mb-0 fs-16 fw-600 info-text'>Physical Store</h2>
                <h2 className='mb-0 fs-16 fw-400 secondary-color info-text'>{warrantDetail?.store?.store_name}</h2>
            </div>
            <div className='col-md-4 d-flex gap-2 d-md-block'>
                <h2 className='mb-0 fs-16 fw-600 info-text'>Order ID</h2>
                <h2 className='mb-0 fs-16 fw-400 secondary-color info-text'>{warrantDetail?.order?.order_id_display}</h2>
            </div>
            <div className='col-md-4 d-flex gap-2 d-md-block'>
                <h2 className='mb-0 fs-16 fw-600 info-text'>Product ID</h2>
                <h2 className='mb-0 fs-16 fw-400 secondary-color info-text'>{warrantDetail?.product?.product_id_display}</h2>
            </div>
        </div>
        <div className='mt-2 mt-md-3'>
            <h2 className='mb-0 fs-16 fw-600 info-text'>Warranty Claim For</h2>
            <h2 className='mb-0 fs-16 fw-400 secondary-color info-text'>{findConstantLabel(constant?.warrantee_claim_for, warrantDetail?.claimed_for)}</h2>
        </div>

        <div className="mt-2 mt-md-4 fs-20 fw-600 secondary-color info-text">Product Images</div>
        <div className='row'>
            {warrantDetail?.images && warrantDetail?.images.map((productImage: any, index: number) => {
                return (
                    <div className="d-flex flex-wrap gap-4 col-2">
                        <div className="mt-3 info-cover-img position-relative" >
                            <Image className="info-cover-img" src={productImage} />
                        </div>
                    </div>
                )
            })}
        </div>

        <div className="info-style mt-3" >
            <h2 className="mb-0 fs-16 fw-600 secondary-color info-text"> Product Condition Remark :</h2>
            <h2 className="mb-0 fs-16 fw-400 secondary-color info-text mx-2">{warrantDetail?.condition_remark}</h2>
        </div>

    </>
    )
}